export enum LocalFileSystem {
  PERSISTENT = 0,
  TEMPORARY = 1
}
